import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {LoginPage} from './login';
import {OauthService} from '../../shared/services/oauth.service';
import {LoginService} from './services/login.service';
import {MessageService} from '../../shared/services/message.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CoreModule} from "../../core";
import { MenuService } from '../../shared/services/menu.service';

@NgModule({
    declarations: [
        LoginPage,
    ],
    imports: [
        IonicPageModule.forChild(LoginPage),
        FormsModule,
        ReactiveFormsModule,
        CoreModule,
    ],
    providers: [
        OauthService,
        LoginService,
        MessageService,
        MenuService,
    ]
})
export class LoginPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/login/login.module.ts